import React from 'react';
import { Grid } from '@mui/material';
import { MobileApps, MobileAppVideos } from '../MobileApps.js';

export function MobileAppsPage() {
  return (
    <Grid container spacing={1}>
      <MobileAppVideos />
      <MobileApps />
    </Grid>
  );
}
